import { green, orange, red } from "@mui/material/colors";
import ActionButtonTile from "../components/v2/dashboard/components/ActionButtonTile";
import AppFunnelChart from "../components/v2/dashboard/components/AppFunnelChart";
import AppPieChart from "../components/v2/dashboard/components/AppPieChart";
import CSATWidget from "../components/v2/dashboard/components/CSATWidget";
import GaugeRing from "../components/v2/dashboard/components/GaugeRing";
import NumericTile from "../components/v2/dashboard/components/NumericTile";
import RecentActivityTimeline from "../components/v2/dashboard/components/RecentActivityTimeline";
import ResponseTimeChart from "../components/v2/dashboard/components/ResponseTimeChart"; // Commented for demo
import SessionsChart from "../components/v2/dashboard/components/SessionsChart";
import SLAComplianceWidget from "../components/v2/dashboard/components/SLAComplianceWidget";
// import TicketAgingBar from "../components/v2/dashboard/components/TicketAgingBar"; // Commented for demo
import AppBarChart from "../components/v2/dashboard/components/AppBarChart";
import TicketAgingBar from "../components/v2/dashboard/components/TicketAgingBar";
import {
  ROLE_ADMIN,
  ROLE_MANAGER,
  ROLE_RESOLVER,
  ROLE_USER,
} from "./RolesConstants";

// Commented for demo - replaced with new chart types
// const slaBreachData = [
//   { label: "Met SLA", value: 187 },
//   { label: "Near Breach (Within 2hrs)", value: 23 },
//   { label: "SLA Breached", value: 12 },
// ];

// const categoryDataSample = [
//   { label: "Hardware Issues", value: 28 },
//   { label: "Software/Applications", value: 45 },
//   { label: "Network & Connectivity", value: 22 },
//   { label: "User Access & Permissions", value: 18 },
//   { label: "Email & Communication", value: 12 },
//   { label: "Security & Compliance", value: 8 },
//   { label: "Data & Backup", value: 6 },
//   { label: "Other", value: 11 },
// ];

// Sample data for ticket status distribution
const ticketStatusData = [
  { label: "Open", value: 45 },
  { label: "In Progress", value: 32 },
  { label: "Waiting on Customer", value: 18 },
  { label: "On Hold", value: 8 },
  { label: "Resolved", value: 125 },
];

// Sample data for open tickets over the last 30 days
const openTicketsData = {
  labels: [
    "Day 1",
    "Day 2",
    "Day 3",
    "Day 4",
    "Day 5",
    "Day 6",
    "Day 7",
    "Day 8",
    "Day 9",
    "Day 10",
    "Day 11",
    "Day 12",
    "Day 13",
    "Day 14",
    "Day 15",
    "Day 16",
    "Day 17",
    "Day 18",
    "Day 19",
    "Day 20",
    "Day 21",
    "Day 22",
    "Day 23",
    "Day 24",
    "Day 25",
    "Day 26",
    "Day 27",
    "Day 28",
    "Day 29",
    "Day 30",
  ],
  data: [
    {
      label: "Open",
      value: [
        12, 15, 18, 14, 16, 20, 22, 19, 17, 25, 28, 24, 26, 30, 27, 29, 32, 35,
        31, 28, 26, 24, 27, 30, 33, 29, 25, 23, 21, 18,
      ],
    },
    {
      label: "In Progress",
      value: [
        8, 10, 12, 9, 11, 14, 16, 13, 12, 18, 20, 17, 19, 22, 20, 21, 24, 26,
        23, 20, 18, 16, 19, 22, 25, 21, 17, 15, 14, 12,
      ],
    },
    {
      label: "Resolved",
      value: [
        5, 7, 8, 6, 7, 9, 11, 8, 7, 12, 14, 11, 13, 16, 14, 15, 18, 20, 17, 14,
        12, 10, 13, 16, 19, 15, 11, 9, 8, 6,
      ],
    },
  ],
  changePercent: 12,
};

// Enhanced closed tickets data with realistic monthly trends and resolution categories
const closedTicketsData = {
  labels: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ],
  data: [
    {
      label: "Auto-Resolved",
      values: [45, 52, 48, 58, 61, 67, 72, 69, 64, 71, 68, 74],
      stack: "A",
    },
    {
      label: "Agent Resolved",
      values: [89, 96, 103, 112, 108, 125, 134, 128, 119, 142, 138, 151],
      stack: "A",
    },
    {
      label: "Escalated & Resolved",
      values: [23, 28, 31, 35, 32, 39, 42, 38, 35, 45, 41, 48],
      stack: "A",
    },
  ],
  changePercent: 28,
};

const categoryDataSample = [
  { label: "Hardware", value: 15 },
  { label: "Software", value: 30 },
  { label: "Network", value: 10 },
  { label: "Other", value: 5 },
];

// Sample data for scatter chart - Response Time vs Resolution Time
const scatterChartData = {
  series: [
    {
      id: "critical",
      label: "Critical",
      data: [
        { x: 2, y: 45, id: 1 },
        { x: 5, y: 78, id: 2 },
        { x: 3, y: 52, id: 3 },
        { x: 8, y: 95, id: 4 },
        { x: 4, y: 67, id: 5 },
      ],
    },
    {
      id: "high",
      label: "High",
      data: [
        { x: 10, y: 120, id: 6 },
        { x: 15, y: 180, id: 7 },
        { x: 12, y: 145, id: 8 },
        { x: 18, y: 210, id: 9 },
        { x: 14, y: 165, id: 10 },
      ],
    },
    {
      id: "medium",
      label: "Medium",
      data: [
        { x: 25, y: 240, id: 11 },
        { x: 30, y: 290, id: 12 },
        { x: 35, y: 320, id: 13 },
        { x: 28, y: 275, id: 14 },
        { x: 32, y: 310, id: 15 },
      ],
    },
  ],
  changePercent: 8,
};

// Sample data for radar chart - Support team performance
const radarChartData = {
  data: [
    { subject: "Response Time", value: 85, target: 90 },
    { subject: "Resolution Quality", value: 92, target: 95 },
    { subject: "Customer Satisfaction", value: 88, target: 90 },
    { subject: "First Call Resolution", value: 76, target: 80 },
    { subject: "Knowledge Base Usage", value: 82, target: 85 },
    { subject: "Team Collaboration", value: 94, target: 90 },
  ],
  series2: false,
  changePercent: 5,
};

// Sample data for funnel chart - Ticket resolution process
const funnelChartData = {
  stages: [
    { label: "Total Tickets", value: 1250 },
    { label: "Assigned", value: 1180 },
    { label: "In Progress", value: 950 },
    { label: "Under Review", value: 720 },
    { label: "Resolved", value: 680 },
  ],
  changePercent: 12,
};

// Sample data for SLA Status - Breached or at-risk SLAs
const slaStatusData = [
  { label: "Within SLA", value: 187 },
  { label: "At Risk (nearing breach)", value: 23 },
  { label: "Breached SLA", value: 12 },
];

// Sample data for heatmap chart - Ticket volume by time and day
const heatmapChartData = {
  matrix: [
    [12, 15, 18, 22, 25, 20, 16],
    [8, 12, 16, 20, 28, 24, 18],
    [10, 14, 20, 26, 32, 28, 22],
    [6, 10, 14, 18, 24, 20, 14],
    [4, 8, 12, 16, 20, 18, 12],
  ],
  xLabels: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
  yLabels: ["9-11 AM", "11-1 PM", "1-3 PM", "3-5 PM", "5-7 PM"],
  changePercent: 15,
};

// Sample data for area chart - System performance metrics
const areaChartData = {
  labels: [
    "Week 1",
    "Week 2",
    "Week 3",
    "Week 4",
    "Week 5",
    "Week 6",
    "Week 7",
    "Week 8",
  ],
  series: [
    {
      label: "CPU Usage",
      data: [65, 72, 68, 75, 70, 78, 73, 69],
    },
    {
      label: "Memory Usage",
      data: [45, 52, 48, 58, 55, 62, 57, 51],
    },
    {
      label: "Network I/O",
      data: [25, 32, 28, 35, 30, 38, 33, 29],
    },
  ],
  changePercent: -3,
};

// Sample data for Customer Satisfaction (CSAT) Score
const csatData = {
  averageScore: 4.3,
  totalResponses: 1247,
  changePercent: 8,
  distribution: [
    { stars: 5, count: 542 },
    { stars: 4, count: 398 },
    { stars: 3, count: 187 },
    { stars: 2, count: 76 },
    { stars: 1, count: 44 },
  ],
};

// Sample data for SLA Compliance
const slaComplianceData = {
  complianceRate: 92.3,
  targetRate: 95.0,
  changePercent: 3.2,
  breakdown: {
    onTime: 1847,
    nearBreach: 98,
    breached: 55,
  },
};

// const colors = ["#42a5f5", "#ffb300", "#66bb6a", "#ef5350", "#ab47bc"]; // Commented for demo

export const WIDGET_COMPONENTS = {
  OPEN_TICKETS: "OpenTickets",
  CLOSED_TICKETS: "ClosedTickets",
  TICKETS_BY_CATEGORY: "TicketsByCategory",
  CUSTOMER_SATISFACTION_SCORE: "CustomerSatisfactionScore",
  TICKET_STATUS: "TicketStatus",
  UNASSIGNED_TICKETS: "UnassignedTickets",
  ESCALATED_TICKETS: "EscalatedTickets",
  SLA_STATUS: "SlaStatus",
  SLA_COMPLIANCE: "SlaCompliance",
  TICKET_RESOLUTION_RATE: "ResolutionRate",
  AVERAGE_RESPONSE_TIME: "ResponseTimeChart",
  TICKET_AGING_REPORT: "TicketAgingBar",
  RECENT_ACTIVITY: "RecentActivity",
  QUICK_ACTION: "QuickAction",
};

export const WIDGET_DEFINITIONS = {
  [WIDGET_COMPONENTS.OPEN_TICKETS]: {
    name: "My Open Tickets",
    defaultProps: {
      data: openTicketsData,
      title: "Analysis of Ticket Trends for the Past 30 Days",
      headerName: "My Open Tickets",
    },
    defaultLayout: { x: 0, y: 0, w: 6, h: 4, minW: 4, minH: 3 },
    component: SessionsChart,
  },
  [WIDGET_COMPONENTS.CLOSED_TICKETS]: {
    name: "Closed Tickets",
    defaultProps: {
      data: closedTicketsData,
      title: "Monthly ticket resolution breakdown by resolution type",
      headerName: "Closed Tickets",
    },
    defaultLayout: { x: 6, y: 0, w: 6, h: 4, minW: 4, minH: 3 },
    component: AppBarChart,
  },
  [WIDGET_COMPONENTS.SLA_STATUS]: {
    name: "SLA Status",
    defaultProps: {
      data: slaStatusData,
      title: "Current ticket status distribution",
      colors: [red[300], orange[300], orange[200], red[200], green[400]],
    },
    defaultLayout: { x: 0, y: 4, w: 6, h: 4, minW: 3, minH: 3 },
    component: AppPieChart,
  },
  [WIDGET_COMPONENTS.TICKETS_BY_CATEGORY]: {
    name: "Tickets by Category",
    defaultProps: {
      data: categoryDataSample,
      title: "Tickets by Category",
      colors: ["#42a5f5", "#ffb300", "#66bb6a", "#ef5350", "#ab47bc"],
    },
    defaultLayout: { x: 6, y: 4, w: 6, h: 4, minW: 3, minH: 3 },
    component: AppPieChart,
  },
  [WIDGET_COMPONENTS.UNASSIGNED_TICKETS]: {
    name: "Unassigned Tickets",
    defaultProps: { title: "Unassigned Tickets", value: 23, deltaPercent: -8 },
    defaultLayout: { x: 0, y: 8, w: 2, h: 2, minW: 2, minH: 2 },
    component: NumericTile,
  },
  [WIDGET_COMPONENTS.ESCALATED_TICKETS]: {
    name: "Escalated Tickets",
    defaultProps: { title: "Escalated Tickets", value: 7, deltaPercent: 15 },
    defaultLayout: { x: 0, y: 10, w: 2, h: 2, minW: 2, minH: 2 },
    component: NumericTile,
  },
  [WIDGET_COMPONENTS.TICKET_STATUS]: {
    name: "Ticket Status",
    defaultProps: {
      title: "Ticket Resolution Funnel Analysis",
      data: funnelChartData,
    },
    defaultLayout: { x: 2, y: 8, w: 4, h: 4, minW: 3, minH: 3 },
    component: AppFunnelChart, // Changed from AppPieChart to demonstrate funnel chart
  },
  [WIDGET_COMPONENTS.TICKET_AGING_REPORT]: {
    name: "Ticket Aging Report",
    defaultProps: {
      title: "Open tickets categorized by time",
      groups: [
        {
          label: "0-24 hrs",
          values: { Open: 18, "In Progress": 12, Resolved: 8 },
        },
        {
          label: "1-3 days",
          values: { Open: 14, "In Progress": 16, Resolved: 11 },
        },
        {
          label: "4-7 days",
          values: { Open: 9, "In Progress": 8, Resolved: 5 },
        },
        {
          label: "1-2 weeks",
          values: { Open: 6, "In Progress": 4, Resolved: 2 },
        },
        {
          label: "2+ weeks",
          values: { Open: 3, "In Progress": 2, Resolved: 1 },
        },
      ],
      seriesLabels: ["Open", "In Progress", "Resolved"],
    },
    defaultLayout: { x: 6, y: 8, w: 6, h: 4, minW: 4, minH: 3 },
    component: TicketAgingBar,
  },
  [WIDGET_COMPONENTS.TICKET_RESOLUTION_RATE]: {
    name: "Ticket Resolution Rate",
    defaultProps: {
      title: "Ticket Resolution Rate",
      value: 72,
      color: orange[500],
    },
    defaultLayout: { x: 0, y: 0, w: 6, h: 4, minW: 3, minH: 3 },
    component: GaugeRing,
  },
  [WIDGET_COMPONENTS.AVERAGE_RESPONSE_TIME]: {
    name: "Average Response Time",
    defaultProps: { title: "Average Response Time" },
    defaultLayout: { x: 6, y: 0, w: 6, h: 4, minW: 4, minH: 3 },
    component: ResponseTimeChart,
  },
  [WIDGET_COMPONENTS.SLA_COMPLIANCE]: {
    name: "SLA Compliance",
    defaultProps: {
      data: slaComplianceData,
      title: "Percentage of tickets resolved within agreed SLA time",
    },
    defaultLayout: { x: 0, y: 4, w: 6, h: 4, minW: 3, minH: 3 },
    component: SLAComplianceWidget,
  },
  [WIDGET_COMPONENTS.CUSTOMER_SATISFACTION_SCORE]: {
    name: "Customer Satisfaction (CSAT) Score",
    defaultProps: {
      data: csatData,
      title: "User feedback on resolved tickets",
    },
    defaultLayout: { x: 6, y: 4, w: 6, h: 4, minW: 3, minH: 3 },
    component: CSATWidget, // Professional CSAT widget with gauge and star ratings
  },
  [WIDGET_COMPONENTS.RECENT_ACTIVITY]: {
    name: "Recent Activity Feed",
    defaultProps: {
      title: "Recent Activity Feed",
      items: [
        { time: "11:45", text: "Ticket #2547 assigned to Sarah Wilson" },
        {
          time: "11:20",
          text: "High priority ticket #2548 created - Network outage",
        },
        { time: "10:55", text: "Ticket #2543 status changed to Resolved" },
        { time: "10:30", text: "Comment added on Ticket #2545 by Mike Chen" },
        { time: "10:15", text: "Ticket #2541 escalated to Level 2 support" },
        { time: "09:45", text: "SLA breached for Ticket #2539" },
        { time: "09:20", text: "Ticket #2540 merged with #2538" },
        {
          time: "08:55",
          text: "New ticket #2546 created - Software installation issue",
        },
        { time: "Yesterday", text: "15 tickets resolved by support team" },
        { time: "Yesterday", text: "Monthly SLA compliance: 94.2%" },
      ],
    },
    defaultLayout: { w: 6, h: 4, minW: 4, minH: 3 },
    component: RecentActivityTimeline,
  },
  [WIDGET_COMPONENTS.QUICK_ACTION]: {
    name: "Create New Ticket",
    defaultProps: { title: "Create New Ticket" },
    defaultLayout: { w: 3, h: 2, minW: 2, minH: 2 },
    component: ActionButtonTile,
  },
};

const RESOLVER_DASHBOARD_SECTIONS = [
  {
    id: "ticket-overview-management",
    title: "Ticket Overview & Management",
    widgets: [
      WIDGET_COMPONENTS.OPEN_TICKETS,
      WIDGET_COMPONENTS.UNASSIGNED_TICKETS,
      WIDGET_COMPONENTS.ESCALATED_TICKETS,
      WIDGET_COMPONENTS.TICKET_STATUS,
      WIDGET_COMPONENTS.CLOSED_TICKETS,
      WIDGET_COMPONENTS.TICKET_AGING_REPORT,
      WIDGET_COMPONENTS.SLA_STATUS,
      WIDGET_COMPONENTS.TICKETS_BY_CATEGORY,
    ],
  },
  {
    id: "performance-metrics-analytics",
    title: "Performance Metrics & Analytics",
    widgets: [
      WIDGET_COMPONENTS.TICKET_RESOLUTION_RATE,
      WIDGET_COMPONENTS.AVERAGE_RESPONSE_TIME,
      WIDGET_COMPONENTS.SLA_COMPLIANCE,
      WIDGET_COMPONENTS.CUSTOMER_SATISFACTION_SCORE,
    ],
  },
];

export const ROLE_BASED_DASHBOARD_SECTIONS = {
  [ROLE_ADMIN]: RESOLVER_DASHBOARD_SECTIONS,
  [ROLE_USER]: [],
  [ROLE_RESOLVER]: RESOLVER_DASHBOARD_SECTIONS,
  [ROLE_MANAGER]: [],
};
